
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.1667 7.50008V5.83342C14.1667 4.72835 13.7277 3.66854 12.9463 2.88714C12.1649 2.10573 11.1051 1.66675 10 1.66675C8.89497 1.66675 7.83516 2.10573 7.05376 2.88714C6.27236 3.66854 5.83337 4.72835 5.83337 5.83342V7.50008C5.17033 7.50008 4.53445 7.76347 4.06561 8.23231C3.59677 8.70116 3.33337 9.33704 3.33337 10.0001V15.8334C3.33337 16.4965 3.59677 17.1323 4.06561 17.6012C4.53445 18.07 5.17033 18.3334 5.83337 18.3334H14.1667C14.8297 18.3334 15.4656 18.07 15.9345 17.6012C16.4033 17.1323 16.6667 16.4965 16.6667 15.8334V10.0001C16.6667 9.33704 16.4033 8.70116 15.9345 8.23231C15.4656 7.76347 14.8297 7.50008 14.1667 7.50008ZM7.50004 5.83342C7.50004 5.17037 7.76343 4.53449 8.23227 4.06565C8.70111 3.59681 9.337 3.33341 10 3.33341C10.6631 3.33341 11.299 3.59681 11.7678 4.06565C12.2366 4.53449 12.5 5.17037 12.5 5.83342V7.50008H7.50004V5.83342ZM15 15.8334C15 16.0544 14.9122 16.2664 14.756 16.4227C14.5997 16.579 14.3877 16.6667 14.1667 16.6667H5.83337C5.61236 16.6667 5.4004 16.579 5.24412 16.4227C5.08784 16.2664 5.00004 16.0544 5.00004 15.8334V10.0001C5.00004 9.77907 5.08784 9.56711 5.24412 9.41083C5.4004 9.25455 5.61236 9.16675 5.83337 9.16675H14.1667C14.3877 9.16675 14.5997 9.25455 14.756 9.41083C14.9122 9.56711 15 9.77907 15 10.0001V15.8334Z","fill":"currentColor"}})])
          )
        }
      }
    